var map = {
	"./de.json": [
		873,
		873
	],
	"./en.json": [
		53,
		53
	],
	"./es.json": [
		406,
		406
	],
	"./fr.json": [
		222,
		222
	],
	"./it.json": [
		767,
		767
	],
	"./nl.json": [
		920,
		920
	],
	"./pl.json": [
		690,
		690
	],
	"./pt.json": [
		34,
		34
	],
	"./ru.json": [
		335,
		335
	],
	"./tr.json": [
		584,
		584
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 631;
module.exports = webpackAsyncContext;